import { render, staticRenderFns } from "./musicCards.vue?vue&type=template&id=3b1fe3e1&"
import script from "./musicCards.vue?vue&type=script&lang=ts&"
export * from "./musicCards.vue?vue&type=script&lang=ts&"
import style0 from "./musicCards.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports